/* eslint-disable default-case */
import produce from 'immer';
import get from 'lodash.get';
import * as Sentry from '@sentry/browser';
import { create } from 'services/api';
import { immerSet } from './util';

export const FEATURE_FLAGS_REQUESTED = 'create/feature-flags/FETCH';
export const FEATURE_FLAGS_RECEIVED = 'create/feature-flags/RECEIVE';
export const FEATURE_FLAGS_FAILED = 'create/feature-flags/FAILED';
export const FEATURE_FLAG_ERROR_STATUS = 'ERROR';
export const FEATURE_FLAG_LOADING_STATUS = 'LOADING';
export const FEATURE_FLAG_LOADED_STATUS = 'LOADED';

export const selectShowFeatureFlags = showId => state => {
  const showFeatureFlags = get(state, ['v2', 'featureFlags', 'shows', showId, 'flags'], []);

  return showFeatureFlags.map(feature => feature.name);
};

export const selectAllShowFeatureFlags = state => {
  return get(state, ['v2', 'featureFlags', 'shows'], []);
};

export const selectShowFeatureFlagsStatus = showId => state => {
  return get(state, ['v2', 'featureFlags', 'shows', showId, 'status']);
};

const initialState = {
  shows: {},
};

export default produce((state, { type, payload }) => {
  switch (type) {
    case FEATURE_FLAGS_REQUESTED: {
      immerSet(state, ['shows', payload.showId, 'flags'], []);
      immerSet(state, ['shows', payload.showId, 'status'], FEATURE_FLAG_LOADING_STATUS);
      break;
    }

    case FEATURE_FLAGS_RECEIVED: {
      immerSet(state, ['shows', payload.showId, 'flags'], payload.items);
      immerSet(state, ['shows', payload.showId, 'status'], FEATURE_FLAG_LOADED_STATUS);
      break;
    }

    case FEATURE_FLAGS_FAILED: {
      immerSet(state, ['shows', payload.showId, 'flags'], []);
      immerSet(state, ['shows', payload.showId, 'status'], FEATURE_FLAG_ERROR_STATUS);
      break;
    }
  }
}, initialState);

export const fetchShowFeatureFlags = showId => (dispatch, getState) => {
  const state = getState();
  const status = selectShowFeatureFlagsStatus(showId)(state);

  if ([FEATURE_FLAG_LOADING_STATUS, FEATURE_FLAG_LOADED_STATUS].includes(status)) {
    return Promise.resolve();
  }

  dispatch({
    type: FEATURE_FLAGS_REQUESTED,
    payload: { showId },
  });

  return create
    .get(`/api-v3/shows/${showId}/features`)
    .then(response => {
      dispatch({
        type: FEATURE_FLAGS_RECEIVED,
        payload: response.body,
      });
    })
    .catch(error => {
      dispatch({
        type: FEATURE_FLAGS_FAILED,
        payload: { showId },
      });

      Sentry.captureException(error);
    });
};
